import { TimelineLite, Power0 } from 'gsap';

const animation = (audioFn) => {
    const tl = new TimelineLite();

    tl.eventCallback('onStart', audioFn)
        .set(['.replay-section', '.faq-form__submit', '.faq-section__link'], {pointerEvents: 'none'})
        .from('.death-certificate__heading', .8, {alpha: 0, ease: Power0.easeNone }, '+=.2')
        .staggerFrom('.death-certificate__content p', .8, {alpha: 0, ease: Power0.easeNone, delay: .3}, 0.7)
        .from('.faq-section', .8, {alpha: 0 }, '+=0.3')
        .staggerFrom('.faq-item', .8, { alpha: 0, ease: Power0.easeNone}, 0.3, '+=.3')
        .set('.faq-form__submit', {pointerEvents: 'auto'}, '+=.3')
        .from('.faq-form__submit', .8, {alpha: 0, ease: Power0.easeNone})
        .set('.faq-section__link', {pointerEvents: 'auto'}, '+=.3')
        .from('.faq-section__link', .8, {alpha: 0, ease: Power0.easeNone}, '+=.3')
        .set('.replay-section', {pointerEvents: 'auto'}, '+=.3')
        .from('.replay-section', .8, {alpha: 0, delay: 0.3, ease: Power0.easeNone})
} 

export default animation